// TODO: check for configurable scrollBehavior
// https://github.com/nuxt/framework/issues/1707

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.$router.options.scrollBehavior = () => {
    return { left: 0, top: 0 }
  }
})
